// Generic snake_case -> Title Case formatter, shared by any key in this
// feature that has no separate display "name" of its own - document type
// keys (documentTypeLabel) and, per Frontend PRD 04, field keys/response_tags
// alike.
export function snakeToTitleCase(key: string): string {
  return key
    .split('_')
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ')
}

// Formats a document_types.json key (e.g. "memorandum_of_sale") into a
// display label ("Memorandum Of Sale") - document type entries have no
// separate "name" field of their own. Mirrors product-types/labels.ts (kept
// local per this repo's per-feature convention rather than cross-imported).
export function documentTypeLabel(key: string): string {
  return snakeToTitleCase(key)
}

export const DOCUMENT_PROMPT_EMPTY_PLACEHOLDER = 'No document-level prompt - using product baseline as-is.'

export const PROMPT_MODE_HELPER_TEXT: Record<'supplement' | 'override', string> = {
  supplement: 'This text will be appended to the baseline prompt above.',
  override: 'This text will completely replace the baseline prompt for this document type.',
}

export const PROMPT_MODE_OPTIONS = [
  { value: 'supplement', label: 'Supplement baseline' },
  { value: 'override', label: 'Override baseline' },
]

export const NOT_ATTACHED_TO_ANY_PRODUCT_TEXT =
  'Not yet attached to any product type - previewing against the extractor default only.'
